import { lazyLoad } from "../../../utils/loadable.js";

export const LazyLuciolesBackground = lazyLoad(
    () => import("./LuciolesBackground.component.js"),
    (module) => module.FloatingLucioles,
    { fallback: null },
);
